const MUI_SPACING_UNIT = 8;

export const convertMUIUnitsToPx = (muiUnits: number) => {
    const pixels = muiUnits * MUI_SPACING_UNIT;
    return pixels;
};
